/* Fit category titles within their available width, while retaining readable limits. */
(() => {
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');
  if (!context) return;

  const categoryParts = original => {
    const data = window.CabaneCategoryNavigation;
    if (!data) return null;
    const url = new URL(location.href), groups = data.groups;
    const handle = decodeURIComponent(url.pathname.split('/collections/')[1]?.split('/')[0] || '');
    const query = url.searchParams.get('q') || '';
    const matches = value => value && (query === value || query.startsWith('(' + value + ') AND '));
    const key = groups[url.searchParams.get('navigation')] ? url.searchParams.get('navigation') : data.mapping[handle];
    const group = groups[key];
    let rootKey = key;
    const visited = new Set();
    while (groups[rootKey]?.parent && groups[rootKey].parent !== 'catalogue' && !visited.has(rootKey)) {
      visited.add(rootKey); rootKey = groups[rootKey].parent;
    }
    const origin = url.searchParams.get('univers');
    if (groups[origin]?.parent === 'catalogue') rootKey = origin;
    const item = group?.items.find(item => handle ? item.handle === handle : matches(new URL(item.url, location.origin).searchParams.get('q')));
    const isGroup = !handle && matches(group?.productQuery);
    if (!handle && !isGroup && !item && !original) return null;
    const english = document.documentElement.lang.startsWith('en');
    const roots = english ? {scooter:'Scooters',skate:'Skateboards',roller:'Skates',hockey:'Hockey & ice skates',bmx:'BMX',protection:'Protection',lifestyle:'Lifestyle'} : {};
    let main = roots[rootKey] || groups[rootKey]?.label || (english ? 'Catalogue' : 'Catalogue');
    if (rootKey === 'catalogue') main = 'Catalogue';
    let detail = isGroup ? group.label : item?.label || original;
    const stripFamily = text => (text || '').replace(/\b(trottinettes?|scooters?)\b/gi, match => rootKey === 'scooter' ? '' : match)
      .replace(/\bskateboards?\b/gi, match => rootKey === 'skate' ? '' : match)
      .replace(/\brollers?\b/gi, match => rootKey === 'roller' ? '' : match)
      .replace(/\bBMX\b/gi, match => rootKey === 'bmx' ? '' : match)
      .replace(/\bprotections?\b/gi, match => rootKey === 'protection' ? '' : match)
      .replace(/\s+/g,' ').trim().replace(/^(de |d[’']|·\s*|&\s*)|\s+(de|d[’']|·|&)$/gi,'').trim();
    detail = stripFamily(detail);
    if (!detail && group && key !== rootKey) detail = stripFamily(group.label);
    if (handle === 'trottinettes-freestyles-completes') { main = english ? 'Scooters' : 'Trottinettes'; detail = english ? 'Complete freestyle scooters' : 'Freestyle complètes'; }
    if (handle === 'trottinettes-trampoline') detail = 'Trampoline';
    if (isGroup && key === rootKey || detail.toLowerCase() === main.toLowerCase()) detail = '';
    return { main, detail: detail || (english ? 'Full selection' : 'Toute la sélection') };
  };

  const tracked = new WeakSet();
  const bind = () => document.querySelectorAll('.cabane-category-design .collection-hero__title').forEach(heading => {
    if (tracked.has(heading)) return;
    tracked.add(heading);
    const original = heading.dataset.cabaneCategoryOriginal || heading.querySelector('.cabane-category-title-main')?.textContent.trim() || heading.textContent.trim();
    const parts = categoryParts(original);
    const harmonise = () => {
      if (!parts) return;
      for (const node of [...heading.childNodes]) {
        if (node.nodeType === Node.TEXT_NODE && node.textContent.trim()) node.remove();
      }
      for (const [suffix, text] of [['main', parts.main], ['detail', parts.detail]]) {
        let line = heading.querySelector('.cabane-category-title-' + suffix);
        if (!line) { line = document.createElement('span'); line.className = 'cabane-category-title-' + suffix; heading.append(document.createTextNode(' '), line); }
        if (line.textContent !== text) line.textContent = text;
      }
    };
    let frame;
    const fit = () => {
      harmonise();
      const title = heading.querySelector('.cabane-category-title-main');
      if (!title || !heading.clientWidth) return;
      const detail = heading.querySelector('.cabane-category-title-detail');
      if (detail) {
        const maximumDetail = innerWidth < 750 ? 22 : 24;
        context.font = '400 ' + maximumDetail + 'px Anton';
        const measured = context.measureText(detail.textContent.trim().toUpperCase()).width;
        const fitted = Math.max(18, Math.min(maximumDetail, Math.floor(maximumDetail * (heading.clientWidth - 2) / Math.max(measured, 1))));
        detail.style.setProperty('--category-detail-fit', fitted + 'px');
      }
      const style = getComputedStyle(heading);
      const maximum = Number(style.getPropertyValue('--category-title-max')) || 56;
      const minimum = Number(style.getPropertyValue('--category-title-min')) || 32;
      context.font = `400 ${maximum}px Anton`;
      const text = title.textContent.trim().toUpperCase();
      const width = context.measureText(text).width;
      const size = Math.max(minimum, Math.min(maximum, Math.floor(maximum * (heading.clientWidth - 2) / Math.max(width, 1))));
      const value = `${size}px`;
      if (title.style.getPropertyValue('--category-title-fit') !== value) title.style.setProperty('--category-title-fit', value);
    };
    const schedule = () => { cancelAnimationFrame(frame); frame = requestAnimationFrame(fit); };
    new ResizeObserver(schedule).observe(heading);
    new MutationObserver(schedule).observe(heading, {childList: true, characterData: true, subtree: true});
    document.fonts.ready.then(schedule);
    harmonise();
    schedule();
  });
  bind();
  document.addEventListener('shopify:section:load', bind);
})();
